import { computed, reactive, watch } from 'vue'
import { querySmsDemandAuditStats } from '@/api/modules/dataCenter'

/** 订阅短信审核状态统计信息 */
export function useSmsAuditStats(state) {
  const stateMap = reactive({
    2: [],
    3: [],
    6: []
  })
  const smsAuditStats = computed(() => {
    return stateMap[state.value] || []
  })
  watch(state, (val) => {
    if (!val) {
      return
    }
    if (smsAuditStats.value.length) {
      return
    }
    querySmsDemandAuditStats(val).then(res => {
      if (!res.data || !res.data.length) {
        smsAuditStatsChartSeries.value = []
        return
      }
      stateMap[state.value] = res.data
    })
  }, {
    immediate: true
  })
  return {
    smsAuditStats
  }
}
